export const A = "A";
export const R = "R";
export const defaultPageCount = 25;
export const longTerm = "Long Term";
export const active = "Active";

export const shelvesCount = 6;
export const shelvesTotalCount = 999999;
